import React, { useState } from 'react';
import { useClinica } from '../lib/clinica';

/**
 * El logo de la clínica en las páginas del paciente (V2, 28/9/2026).
 *
 * Antes era un JPG empaquetado en el frontend: el de una clínica concreta,
 * que salía en cualquier instalación. Ahora es el que la clínica sube en
 * Configuración y sirve `/api/public/branding/logo` (sin login, solo el logo).
 *
 * La página del paciente no se puede romper por esto: si no hay logo subido
 * (`/api/public/branding` dice `logo_light: false`), o la imagen no carga, se
 * pinta el nombre de la clínica en texto (`conNombre`) o nada, si la página
 * ya lo enseña al lado.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export default function LogoClinica({ className = '', conNombre = false, variante = 'light' }) {
  const clinica = useClinica();
  const [fallo, setFallo] = useState(false);
  const hayLogo = variante === 'dark' ? clinica.logo_dark : clinica.logo_light;
  if (hayLogo && !fallo) {
    return (
      <img
        src={`${BACKEND_URL}/api/public/branding/logo?variant=${variante}`}
        alt={clinica.clinic_name || 'Logo de la clínica'}
        className={className}
        onError={() => setFallo(true)}
        data-testid="logo-clinica"
      />
    );
  }
  if (!conNombre || !clinica.clinic_name) return null;
  return (
    <span className="font-display font-semibold text-[#13231E] leading-tight" data-testid="logo-clinica-nombre">
      {clinica.clinic_name}
    </span>
  );
}
